import React from "react";
import DynamicLayout from "../components/DynamicLayout";
import RetrogradeExperience from "../components/tools/RetrogradeExperience";
import '../assets/ascendant-display.sass';

const RetrogradesPage = () => {
    return (
        <DynamicLayout>
            <RetrogradeExperience />
        </DynamicLayout>
    );
};

export default RetrogradesPage; 
